import React, { useState, useEffect, useRef } from "react";
import UploadIn from '../../assets/images/icon/UploadIp.svg';
import DeleteIcon from '../../assets/images/delete.svg';
import noteIcon from '../../assets/images/noteIcon.svg';
import Row from 'react-bootstrap/Row';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { TextField } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError, mixed } from 'yup';
import { Form as RBFORM } from 'react-bootstrap';
import NoteIcon from '../icons/NoteIcon'
import {
    Box,
    Button,
    CircularProgress,
} from '@mui/material';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Grid from "@mui/material/Grid2";
import Stack from '@mui/material/Stack';
import { getCountriesAPI, getStatesAPI, getCitiesAPI } from "../../services/placeService";
import { getMethod, postMethodFormData } from "../../services/apiService";
import { AlertDialogs } from "../dialogs/alertDialogs";
import { useNavigate } from 'react-router-dom';
import { clearStorageAndCookies } from "../../services/authService";
import { ToastContext, useToastContext } from "../../context/toastContext";
import PhoneInput from "react-phone-input-2";
import { usePartnerIdContext } from "../../context/partnerIdContext";
import { PROFILE_TYPE } from "../../helper/globalConstant";
import { isValidPhoneNumber } from 'libphonenumber-js';
import { allTimezones  } from "react-timezone-select";
import { IconUpload } from '@tabler/icons-react';

interface InitialValues {
    partnerid: string;
    name: string;
    email: string;
    addressline1: string;
    addressline2: string;
    postalcode: string;
    city: string | null;
    state: string | null;
    country: string | null;
    number: string;
    mobile: string;
    customerprofileimage: string | null;
    adminname: string;
    adminemail: string;
    adminmobile: string;
    adminprofileimage: string | null;
    submitButtonType?: string; // Optional field
    redirecturl: string;
    timezone: string;
}


export const CustomerFormStep1CustomerInfo = (props: any) => {
    const { setToast } = useToastContext() as ToastContext;
    const navigate = useNavigate();
    const saveexitFormBtn = useRef<HTMLButtonElement | null>(null);
    const adminInputFile = useRef<HTMLInputElement | null>(null);
    const customerInputFile = useRef<HTMLInputElement | null>(null);
    const [countryList, setCountryList] = useState([]);
    const [country, setCountry] = useState("");
    const [stateList, setStateList] = useState([]);
    const [filteredStateList, setFilteredStateList] = useState([]);
    const [state, setState] = useState("");
    const [cityList, setCityList] = useState([]);
    const [filteredCityList, setFilteredCityList] = useState([]);
    const [city, setCity] = useState("");
    const [timezone, setTimezone] = useState("");
    const [customerLogoFile, setCustomerLogoFile] = useState<string | undefined>(undefined);
    const [adminLogoFile, setAdminLogoFile] = useState<string | undefined>(undefined);
    const [handleToast, setHandleToast] = useState(false);
    const [uploadedCustomerLogo, setUploadedCustomerLogo] = useState(null);
    const [uploadedAdminPhoto, setUploadedAdminPhoto] = useState(null);

    function getTimezoneOffset(zone: string) {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: zone,
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
        });

        const parts = formatter.formatToParts(now);
        const localHour = Number(parts.find((p) => p.type === "hour")?.value);
        const localMinute = Number(parts.find((p) => p.type === "minute")?.value);

        const utcHour = now.getUTCHours();
        const utcMinute = now.getUTCMinutes();

        const totalMinutes = (localHour * 60 + localMinute) - (utcHour * 60 + utcMinute);
        return totalMinutes;
    }

    function formatOffset(minutes: number) {
        const sign = minutes >= 0 ? "+" : "-";
        const abs = Math.abs(minutes);
        const hours = String(Math.floor(abs / 60)).padStart(2, "0");
        const mins = String(abs % 60).padStart(2, "0");
        return `UTC${sign}${hours}:${mins}`;
    }

    const timezoneList = Object.keys(allTimezones).map((zone) => {
        const offsetInMinutes = getTimezoneOffset(zone);
        const formatted = formatOffset(offsetInMinutes);

        return {
            label: `(${formatted}) ${zone}`,
            value: zone,
        };
    });

    useEffect(() => {
        getCountryList();
        getStateList();
        getCityList();
        //fetchPartnerId();
    }, []);

    const { partnerId, setPartnerId } = usePartnerIdContext();


    useEffect(() => {
        setInitialValues(prvData => ({
            ...prvData,
            partnerid: partnerId || '',
        }));
    }, [partnerId])



    /* const fetchPartnerId = async () => {
        const id = await getPartnetId();
        setPartnerId(id);
    } */


    const getCountryList = async () => {
        const resp = await getCountriesAPI();
        setCountryList(resp.countries);
    }


    const getStateList = async () => {
        const resp = await getStatesAPI();
        setStateList(resp.states);
    }


    const getCityList = async () => {
        const resp = await getCitiesAPI();
        setCityList(resp.cities);
    }


    const handleCountryChange = async (e: any, setFieldValue: any) => {
        const selectedCountryId = e.target.value;
        const selectedCountry = countryList.find((country: any) => country.id.toString() === selectedCountryId) || { id: '', name: '', shortname: '' };
        setCountry(selectedCountry.id === '' || selectedCountry.id === '0' ? '' : selectedCountry.name);
        setFieldValue("country", selectedCountry.id.toString());

        setTimeout(() => {
            const filteredStates = stateList.filter((state: any) => state.country_id.toString() === selectedCountry.id.toString());
            setFilteredStateList(filteredStates);
        }, 200);
    }


    const handleStateChange = async (e: any, setFieldValue: any) => {
        const selectedStateId = e.target.value;
        const selectedState = stateList.find((state: any) => state.id.toString() === selectedStateId) || { id: '', name: '', country_id: '' };
        setState(selectedState.id === '' || selectedState.id === '0' ? '' : selectedState.name);
        setFieldValue("state", selectedState.id.toString());

        setTimeout(() => {
            const filteredCities = cityList.filter((city: any) => city.state_id.toString() === selectedState.id.toString());
            setFilteredCityList(filteredCities);
        }, 200);
    }


    const handleCityChange = async (e: any, setFieldValue: any) => {
        const selectedCityId = e.target.value;
        const selectedCity = cityList.find((country: any) => country.id.toString() === selectedCityId) || { id: '', name: '', state_id: '' };
        setCity(selectedCity.id === '' || selectedCity.id === '0' ? '' : selectedCity.name);
        setFieldValue("city", selectedCity.id.toString());
    }

    const handleTimeZoneChange = async (e: any, setFieldValue: any) => {
        setTimezone(e.target.value);
        setFieldValue("timezone", e.target.value);
    }


    const handleInputFile = (type: string) => {
        if (type === "customer") {
            if (customerInputFile?.current) {
                customerInputFile!.current.click();
            }
        } else if (type === "admin") {
            if (adminInputFile?.current) {
                adminInputFile!.current.click();
            }
        }
    }


    const previewImage = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
        if (e.target.files && e.target.files[0]) {
            const fileUrl = URL.createObjectURL(e.target.files[0]);
            if (type === "customerprofileimage") setCustomerLogoFile(fileUrl);
            else if (type === "adminprofileimage") setAdminLogoFile(fileUrl);
        }
    }



    /********************************* AlertDialogs Controls **************************************/
    const [open, setOpen] = React.useState(false);

    const handleCancel = async (e: any) => {
        setOpen(true);
    }


    const getConfirmResponse = (action: string) => {
        if (action === 'Yes, Cancel') {
            navigate('/customer/overview');
        } else if (action === 'Save & Exit') {
            saveexitFormBtn.current?.click();
        }
    }


    const [initialValues, setInitialValues] = useState<InitialValues>({
        partnerid: partnerId || '',
        name: '',
        email: '',
        addressline1: '',
        addressline2: '',
        postalcode: '',
        city: null,
        state: null,
        country: null,
        number: '',
        mobile: '',
        customerprofileimage: null,
        adminname: '',
        adminemail: '',
        adminmobile: '',
        adminprofileimage: null,
        submitButtonType: '', // Default value, optional
        redirecturl: '/auth/set-password?uk=',
        timezone: '',
    });

    useEffect(() => {
       
        if (props.customerFormValues != null) {
            setCountryList(props.customerFormValues.countryList);
            setFilteredStateList(props.customerFormValues.filteredStateList);
            setFilteredCityList(props.customerFormValues.filteredCityList);
            setCountry(props.customerFormValues.countryName || "");
            setState(props.customerFormValues.stateName || "");
            setCity(props.customerFormValues.cityName || "");
            setInitialValues(prvData => ({
                ...prvData,
                name: props.customerFormValues.name,
                email: props.customerFormValues.email,
                addressline1: props.customerFormValues.addressline1,
                addressline2: props.customerFormValues.addressline2,
                postalcode: props.customerFormValues.postalcode,
                city: props.customerFormValues.city,
                state: props.customerFormValues.state,
                country: props.customerFormValues.country,
                number: props.customerFormValues.number,
                mobile: props.customerFormValues.mobile,
                //customerprofileimage: props.customerFormValues.customerLogoFile,
                customerprofileimage: uploadedCustomerLogo,
                adminname: props.customerFormValues.adminname,
                adminemail: props.customerFormValues.adminemail,
                adminmobile: props.customerFormValues.adminmobile,
                //adminprofileimage: props.customerFormValues.adminLogoFile,
                adminprofileimage: uploadedAdminPhoto,
                timezone: props.customerFormValues.timezone
            }));

            setCustomerLogoFile(props.customerFormValues.customerLogoFile);
            setAdminLogoFile(props.customerFormValues.adminLogoFile);
            //}
        }
    }, [props.customerFormValues]);




    // This pattern allows an optional + followed by 10 to 15 digits, covering most international formats.
    const phoneRegex = /^\+?\d{10,15}$/;


    const validateEmail = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };


    const [isCustomerEmailAvailable, setIsCustomerEmailAvailable] = useState(true);
    const checkEmailAvailibility = async (value: string, setFieldValue: any) => {
        setFieldValue("adminemail", value);
        if (validateEmail(value)) {
            const resp = await getMethod(`central/user/available/${value}`);
            if (resp?.code === 200) {
                if (!resp?.result?.[0]) {
                    setIsCustomerEmailAvailable(false);
                }
            }
        }
    }


    const handleNameChange = (value: string, setFieldValue: any, values: any) => {
        if (values.name === values.adminname) {
            setFieldValue("adminname", value);
        }
        setFieldValue("name", value);
    }


    const handleEmailChange = (value: string, setFieldValue: any, values: any) => {
        if (values.email === values.adminemail) {
            setFieldValue("adminemail", value);
        }
        setFieldValue("email", value);
    }


    const removePhoto = async (name: string, setFieldValue: any) => {
        if (name === "customerprofileimage") {
            setCustomerLogoFile(undefined);
            setFieldValue("customerprofileimage", "");
            setUploadedCustomerLogo(null);
        } else if (name === "adminprofileimage") {
            setAdminLogoFile(undefined);
            setFieldValue("adminprofileimage", "");
            setUploadedAdminPhoto(null);
        }
    }


    const [profileImageError, setProfileImageError] = useState("");
    const [adminImageError, setAdminImageError] = useState("");
    const handleImageChange = (event: any, name: string, setFieldValue: any, setFieldTouched: any) => {
        const file = event.currentTarget.files[0];

        if (!file) {
            if (name === "customerprofileimage") {
                setProfileImageError("Customer logo is required!");
                setCustomerLogoFile(undefined);
                setFieldValue("customerprofileimage", "");
            }
            return;
        }

        // Check file type
        const validTypes = ["image/jpeg", "image/png"];
        if (!validTypes.includes(file.type)) {
            if (name === "customerprofileimage") {
                setFieldValue("customerprofileimage", "");
                setProfileImageError("Only JPG, and PNG image is allowed!");
                setCustomerLogoFile(undefined);
            } else if (name === "adminprofileimage") {
                setFieldValue("adminprofileimage", "");
                setAdminImageError("Only JPG, and PNG image is allowed!");
                setAdminLogoFile(undefined);
            }
            return;
        }

        // Check file size (should not exceed 500KB)
        const maxSize = 500 * 1024; // 500KB in bytes
        if (file.size > maxSize) {
            if (name === "customerprofileimage") {
                setProfileImageError("Image size should not exceed 500KB!");
                setCustomerLogoFile(undefined);
                setFieldValue("customerprofileimage", "");
            } else if (name === "adminprofileimage") {
                setAdminImageError("Image size should not exceed 500KB!");
                setAdminLogoFile(undefined);
                setFieldValue("adminprofileimage", "");
            }
            return;
        }

        if (name === "customerprofileimage") {
            setCustomerLogoFile(file);
            setFieldValue("customerprofileimage", file);
            setUploadedCustomerLogo(file);
            previewImage(event, "customerprofileimage");
            setFieldTouched("customerprofileimage", true, false);
            setProfileImageError(""); // Clear error if image is valid
        } else if (name === "adminprofileimage") {
            setAdminLogoFile(file);
            setUploadedAdminPhoto(file);
            setFieldValue("adminprofileimage", file);
            previewImage(event, "adminprofileimage");
            setFieldTouched("adminprofileimage", true, false);
            setAdminImageError(""); // Clear error if image is valid
        }

        // Reset the file input to allow re-uploading the same file
        event.target.value = "";
    };


    const checkImageValidity = async (formik_values: any) => {
        if (!formik_values.customerprofileimage) {
            setProfileImageError("Customer logo is required!");
            return;
        }
    }


    const [customerMobileNumber, setCustomerMobileNumber] = useState("");
    const [adminMobileNumber, setAdminMobileNumber] = useState("");
    const validateMobileNumber = async (mobile_number: any, type: string) => {
        if(!mobile_number) {
            if(type === "customer") setCustomerMobileNumber("");
            else if(type === "admin") setAdminMobileNumber("");
            return;
        } 

        if (mobile_number && !mobile_number.includes('+')) {
            mobile_number = `+${mobile_number}`;
        }

        const isValid = isValidPhoneNumber(mobile_number);

        if(!isValid) {
            if(type === "customer") setCustomerMobileNumber("Enter a valid mobile number!");
            if(type === "admin") setAdminMobileNumber("Enter a valid mobile number!");
        } else {
            if(type === "customer") setCustomerMobileNumber("");
            if(type === "admin") setAdminMobileNumber("");
        }
    }

    return (
        <>
            <Formik initialValues={initialValues}
                enableReinitialize={true} // Enable reinitialization
                validationSchema={object({
                    name: string().trim().required("Customer name is required!"),
                    email: string().email("Valid Email ID is required!").required("Email ID is required!"),
                    addressline1: string().trim().optional(),
                    addressline2: string().trim().optional(),
                    postalcode: string().trim().optional(),
                    city: string().nullable().optional(),
                    state: string().nullable().optional(),
                    country: string().nullable().optional(),
                    number: string().trim().matches(/^\d{2,10}$/, "Number must be between 2 to 10 digits").optional(),
                    //mobile: string().trim().optional().matches(phoneRegex, 'Enter a valid phone number'),
                    /* customerprofileimage: mixed()
                        .when("$props.customerInfo", {
                            is: (customerInfo: any) => !customerInfo,
                            then: (schema) =>
                                schema
                                    .test(
                                        "fileSelected",
                                        "Customer logo is required!",
                                        (value, context) => {
                                            if (context.parent.customerprofileimage) return true; // Image is already set
                                            return !!value; // Validate only if no image is set
                                        }
                                    )
                                    .test(
                                        "fileSize",
                                        "File size should be less than 5MB",
                                        (value) => {
                                            if (!value) return true;
                                            const file = value as File;
                                            return file.size <= 5 * 1024 * 1024;
                                        }
                                    )
                                    .test(
                                        "fileType",
                                        "Unsupported file format. Only JPEG, PNG are allowed.",
                                        (value) => {
                                            if (!value) return true;
                                            const file = value as File;
                                            return ["image/jpeg", "image/png"].includes(file.type);
                                        }
                                    ),
                            otherwise: (schema) => schema.optional(), // Make it optional
                        }), */
                    adminname: string().trim().required("Admin name is required!"),
                    adminemail: string().email("Valid Email ID is required!").required("Email ID is required!"),
                    //adminmobile: string().trim().optional().matches(phoneRegex, 'Enter a valid phone number'),
                })}

                onSubmit={async (values, { setSubmitting }) => {
                    if (!props.customerInfo && !values.customerprofileimage) {
                        setProfileImageError("Customer logo is required!");
                        return;
                    }

                    if(customerMobileNumber || adminMobileNumber) {
                        return;
                    }

                    let partnerInfo
                    const sess_user_data = localStorage.getItem("sess_user");
                    if (sess_user_data != null) {
                        try {
                            const sess_user = JSON.parse(sess_user_data);
                            const extractedProfileId = sess_user?.userProfile;
                            if (extractedProfileId) {
                                const priority = extractedProfileId?.priority;
                                if (priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
                                    partnerInfo = extractedProfileId?.ownerId;
                                } else if (priority == PROFILE_TYPE.SUPER_ADMIN) {
                                    partnerInfo = partnerId;
                                } else if (priority == PROFILE_TYPE.INTEGRATOR) {
                                    partnerInfo = partnerId || sess_user?.user?.userId;
                                }
                            } else {
                                console.error("Priority id not found in userProfile");
                            }
                        } catch (error) {
                            console.error("Error parsing session user data:", error);
                        }
                    }
                    const submitButtonType = values.submitButtonType;
                    delete values['submitButtonType'];
                    if (values.mobile && !values.mobile.includes('+')) {
                        values.mobile = `+${values.mobile}`;
                    }
                    if (values.adminmobile && !values.adminmobile.includes('+')) {
                        values.adminmobile = `+${values.adminmobile}`;
                    }

                    let customerFormValues: any = { ...values };
                    customerFormValues['customerLogoFile'] = customerLogoFile;
                    customerFormValues['adminLogoFile'] = adminLogoFile;
                    customerFormValues['countryList'] = countryList;
                    customerFormValues['filteredStateList'] = filteredStateList;
                    customerFormValues['filteredCityList'] = filteredCityList;
                    customerFormValues['countryName'] = country;
                    customerFormValues['stateName'] = state;
                    customerFormValues['cityName'] = city;
                    props.setCustomerFormValues(customerFormValues);

                    values.country = country;
                    values.state = state;
                    values.city = city;
                    values.timezone = timezone;
                    values.partnerid = partnerInfo
                    if (props.customerInfo) {
                        if (submitButtonType === "save&exit") {
                            navigate("/customer/overview");
                        } else {
                            props.setActiveStep(1);
                        }
                    } else {
                        //props.setActiveStep(1);
                        const resp = await postMethodFormData("customer", values);
                        if (resp?.status === 200) {
                            setToast(resp?.data?.message, "success");
                            if (submitButtonType === "next") {
                                props.setCustomerInfo(resp?.data?.result?.[0]);
                                props.setActiveStep(1);
                            } else if (submitButtonType === "save&exit") {
                                navigate("/customer/overview");
                            }
                        } else {
                            setToast(resp?.data?.message, "error");
                        }
                    }
                }}
            >

                {({ values, errors, isSubmitting, isValid, setFieldValue, setFieldTouched, touched }) => (
                    <React.Fragment>
                        <ToastContainer />
                        {/* {JSON.stringify(values, null, 2)} */}

                        <Form autoComplete="off">
                            <Row className="mb-3">
                                <Grid container spacing={3}>
                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Customer Name <span className="start_required">*</span></RBFORM.Label>
                                            <Field
                                                name="name"
                                                type="text"
                                                placeholder="Customer Name"
                                                component={TextField}
                                                className="inputC"
                                                InputProps={{
                                                    readOnly: props?.customerInfo,
                                                }}
                                                onChange={(e: any) => handleNameChange(e.target.value, setFieldValue, values)}
                                            />
                                        </RBFORM.Group>
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Email ID <span className="start_required">*</span></RBFORM.Label>
                                            <Field
                                                name="email"
                                                type="text"
                                                placeholder="Email ID"
                                                component={TextField}
                                                className="inputC"
                                                InputProps={{
                                                    readOnly: props?.customerInfo, // Example dynamic condition
                                                }}
                                                onChange={(e: any) => handleEmailChange(e.target.value, setFieldValue, values)}
                                            />
                                        </RBFORM.Group>
                                    </Grid>
                                </Grid>
                            </Row>

                            <Row className="mb-3">
                                <Grid container columnSpacing={3} rowSpacing={0}>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Address Line 1</RBFORM.Label>
                                            <Field
                                                name="addressline1"
                                                type="text"
                                                placeholder="Street address / company name / c/o"
                                                component={TextField}
                                                className="inputC"
                                                InputProps={{
                                                    readOnly: props?.customerInfo, // Example dynamic condition
                                                }}
                                            />
                                        </RBFORM.Group>
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Address Line 2</RBFORM.Label>
                                            <Field
                                                name="addressline2"
                                                type="text"
                                                placeholder="Apartment / unit / building"
                                                component={TextField}
                                                className="inputC"
                                                InputProps={{
                                                    readOnly: props?.customerInfo, // Example dynamic condition
                                                }}
                                            />
                                        </RBFORM.Group>
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Country</RBFORM.Label>
                                            <Field
                                                name="country"
                                                as="select"
                                                className="inputC custDropdown"
                                                onChange={(e: any) => handleCountryChange(e, setFieldValue)}
                                                disabled={props?.customerInfo}
                                            >
                                                <option>Select Country</option>
                                                {countryList?.length > 0 && (
                                                    countryList.filter((country: any) => country.id !== "0" && country.id !== 0).map((country: any) => (
                                                        <option key={country.id} value={country.id}>
                                                            {country.name}
                                                        </option>
                                                    ))
                                                )}
                                            </Field>
                                        </RBFORM.Group>
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">State</RBFORM.Label>
                                            <Field
                                                name="state"
                                                as="select"
                                                placeholder="State"
                                                className="inputC custDropdown"
                                                onChange={(e: any) => handleStateChange(e, setFieldValue)}
                                                disabled={props?.customerInfo}
                                            >
                                                <option>Select State</option>
                                                {filteredStateList?.length > 0 && (
                                                    filteredStateList.filter((state: any) => state.id !== "0" && state.id !== 0).map((state: any) => (
                                                        <option key={state.id} value={state.id}>
                                                            {state.name}
                                                        </option>
                                                    ))
                                                )}
                                            </Field>
                                        </RBFORM.Group>
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">City</RBFORM.Label>
                                            <Field
                                                name="city"
                                                as="select"
                                                placeholder="City"
                                                className="inputC custDropdown"
                                                onChange={(e: any) => handleCityChange(e, setFieldValue)}
                                                disabled={props?.customerInfo} // Example dynamic condition
                                            >
                                                <option>Select City</option>
                                                {filteredCityList?.length > 0 && (
                                                    filteredCityList.filter((city: any) => city.id !== "0" && city.id !== 0).map((city: any) => (
                                                        <option key={city.id} value={city.id}>
                                                            {city.name}
                                                        </option>
                                                    ))
                                                )}
                                            </Field>
                                        </RBFORM.Group>
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Postal Code</RBFORM.Label>
                                            <Field
                                                name="postalcode"
                                                type="text"
                                                placeholder="Enter Postal Code"
                                                component={TextField}
                                                className="inputC"
                                                InputProps={{
                                                    readOnly: props?.customerInfo, // Example dynamic condition
                                                }}
                                            />
                                        </RBFORM.Group>
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Phone Number</RBFORM.Label>
                                            <Field
                                                name="number"
                                                type="text"
                                                placeholder="Enter Phone Number"
                                                component={TextField}
                                                className="inputC"
                                                InputProps={{
                                                    readOnly: props?.customerInfo, // Example dynamic condition
                                                }}
                                            />
                                        </RBFORM.Group>
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 3 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Mobile Number</RBFORM.Label>
                                            <PhoneInput
                                                specialLabel=""
                                                dropdownClass="user-phone-input-dropdown"
                                                containerClass="user-phone-input-container"
                                                inputClass={`modalForm-input user-phone-input ${errors.mobile && touched.mobile ? "errors" : ""}`}
                                                inputStyle={{
                                                    boxShadow: 'none',
                                                    color: "#A5A8A9",
                                                    border: errors.mobile && touched.mobile ? "1px solid red" : "1px solid #313838",
                                                    width: "100%",
                                                    height: "40px",
                                                    backgroundColor: "#192529",
                                                }}
                                                value={values.mobile}
                                                onChange={(number) => {setFieldValue("mobile", number); validateMobileNumber(number, "customer");}}
                                                /* onChange={(number, data, event, formattedValue) => {
                                                    // number           => 17025656556
                                                    // formattedValue   => +1 (702) 565-6556

                                                    setFieldValue("mobile", formattedValue);        // store formatted
                                                    validateMobileNumber(formattedValue, "customer");
                                                }} */
                                                onBlur={() => setFieldTouched("mobile", true)}
                                                disabled={props?.customerInfo}
                                                enableLongNumbers={true}
                                            />
                                            {customerMobileNumber && (
                                                <div className="error-message" style={{ color: "#f44336" }}>{customerMobileNumber}</div>
                                            )}
                                        </RBFORM.Group>
                                    </Grid>

                                    <Grid size={{ xs: 12}}></Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Timezone</RBFORM.Label>
                                            <Field
                                                name="timezone"
                                                as="select"
                                                className="inputC custDropdown"
                                                onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
                                                disabled={props?.customerInfo}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <option value = "" disabled>Select</option>
                                                {timezoneList.map((tz) => (
                                                    <option key={tz.value} value={tz.value}>
                                                        {tz.label}
                                                    </option>
                                                ))}

                                            </Field>
                                        </RBFORM.Group>
                                    </Grid>

                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span>
                                            {/* <img src={noteIcon} style={{ width: "20px", height: "20px" }} /> */}
                                            <NoteIcon />
                                        </span>
                                        <span
                                            className="label"
                                            style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400", whiteSpace: "nowrap" }}
                                        >
                                            Note: If Timezone is not set, UTC time will be set as default
                                        </span>
                                    </div>

                                    <Grid size={{ xs: 12, md: 12 }}>
                                        <RBFORM.Group className="UploadFld">
                                            <RBFORM.Label className="label">Upload Customer Logo <span className="start_required">*</span></RBFORM.Label>
                                            {!props?.customerInfo &&
                                                <input
                                                    name="customerprofileimage"
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png,.gif"
                                                    className="inputC UploadIn"
                                                    /*  onChange={(e: any) => {
                                                         setFieldValue("customerprofileimage", e.currentTarget.files[0]);
                                                         setFieldTouched("customerprofileimage", true, false); 
                                                         previewImage(e, "customerprofileimage");
                                                     }} */
                                                    onChange={(e: any) => {
                                                        handleImageChange(e, "customerprofileimage", setFieldValue, setFieldTouched);
                                                    }}
                                                    id='file'
                                                    ref={customerInputFile}
                                                    style={{ display: 'none' }}
                                                />
                                            }
                                            {props?.customerInfo &&
                                                <Box
                                                    className="UploadIcon1" style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
                                                    {customerLogoFile &&
                                                        <img src={customerLogoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />
                                                    }
                                                </Box>
                                            }

                                            {!props?.customerInfo &&
                                                <Box
                                                    className="UploadIcon1"
                                                    style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
                                                    {customerLogoFile &&
                                                        <>
                                                            <div className="" style={{ display: "flex", height: "100%", position: "relative" }}>
                                                                <img src={customerLogoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />
                                                                <img src={DeleteIcon} style={{ width: "18px", height: "18px", position: "relative", top: "5px", left: "-20px", cursor: "pointer" }} onClick={(e: any) => removePhoto("customerprofileimage", setFieldValue)} />
                                                            </div>
                                                        </>
                                                    }
                                                    <Box className="UploadIcon" style={{ top: "80px", cursor: 'pointer' }} onClick={() => handleInputFile('customer')}>
                                                        {/* <img src={UploadIn} alt="" width={24} height={24} />  */}
                                                        <IconUpload stroke={1.8} color="#17B2EB" style={{width:"24px", height:"24px"}}/>
                                                        Upload Logo
                                                    </Box>
                                                </Box>
                                            }
                                            {/*  {(errors.customerprofileimage && touched.customerprofileimage) && (
                                                <div style={{ color: "#f44336", fontSize: "0.75rem" }}>Customer logo is required!</div>
                                            )} */}
                                            {profileImageError 
                                            // && touched.customerprofileimage 
                                            && (
                                                <div style={{ color: "#f44336", fontSize: "0.75rem" }}>{profileImageError}</div>
                                            )}
                                        </RBFORM.Group>
                                    </Grid>
                                </Grid>
                            </Row>


                            <Row className="mb-3" style={{ marginTop: '40px' }}>
                                <Grid container className="titleTagIo" spacing={3}>
                                    Register Customer Admin
                                </Grid>
                            </Row>

                            <Row className="mb-3" style={{ paddingBottom: "80px" }}>
                                <Grid container columnSpacing={3} rowSpacing={0}>
                                    <Grid size={{ xs: 12, md: 4 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Customer Admin Name <span className="start_required">*</span></RBFORM.Label>
                                            <Field
                                                name="adminname"
                                                type="text"
                                                placeholder="Enter Customer Admin Name"
                                                component={TextField}
                                                className="inputC"
                                                InputProps={{
                                                    readOnly: props?.customerInfo, // Example dynamic condition
                                                }}
                                            />
                                        </RBFORM.Group>
                                    </Grid>


                                    <Grid size={{ xs: 12, md: 4 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Email ID <span className="start_required">*</span></RBFORM.Label>
                                            <Field
                                                name="adminemail"
                                                type="text"
                                                placeholder="Enter Email ID"
                                                component={TextField}
                                                className="inputC"
                                                InputProps={{
                                                    readOnly: props?.customerInfo, // Example dynamic condition
                                                }}
                                                onChange={(e: any) => checkEmailAvailibility(e.target.value, setFieldValue)}
                                            />
                                        </RBFORM.Group>
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 4 }}>
                                        <RBFORM.Group>
                                            <RBFORM.Label className="label">Mobile Number</RBFORM.Label>
                                            <PhoneInput
                                                specialLabel=""
                                                dropdownClass="user-phone-input-dropdown"
                                                containerClass="user-phone-input-container"
                                                inputClass={`modalForm-input user-phone-input ${errors.adminmobile && touched.adminmobile ? "errors" : ""
                                                    }`}
                                                inputStyle={{
                                                    boxShadow: 'none',
                                                    color: "#A5A8A9",
                                                    border: errors.adminmobile && touched.adminmobile ? "1px solid red" : "1px solid #313838",
                                                    width: "100%",
                                                    height: "40px",
                                                    backgroundColor: "#192529",
                                                }}
                                                value={values.adminmobile}
                                                onChange={(number) => {setFieldValue("adminmobile", number); validateMobileNumber(number, "admin");}}
                                                onBlur={() => setFieldTouched("adminmobile", true)}
                                                disabled={props?.customerInfo}
                                                enableLongNumbers={true}
                                            />
                                            {adminMobileNumber && (
                                                <div className="error-message" style={{ color: "#f44336" }}>{adminMobileNumber}</div>
                                            )}
                                        </RBFORM.Group>
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 12 }}>
                                        <RBFORM.Group className="UploadFld">
                                            <RBFORM.Label className="label">Upload Admin Photo</RBFORM.Label>
                                            {!props?.customerInfo &&
                                                <>
                                                    <input
                                                        name="adminprofileimage"
                                                        type="file"
                                                        accept=".jpg,.jpeg,.png,.gif"
                                                        className="inputC UploadIn"
                                                        /* onChange={(e: any) => {
                                                            setFieldValue("adminprofileimage", e.currentTarget.files[0]);
                                                            previewImage(e, "adminprofileimage");
                                                        }} */
                                                        onChange={(e: any) => {
                                                            handleImageChange(e, "adminprofileimage", setFieldValue, setFieldTouched);
                                                        }}
                                                        id='file'
                                                        ref={adminInputFile}
                                                        style={{ display: 'none' }}
                                                    />
                                                    <Box
                                                        className="UploadIcon1"
                                                        style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
                                                        {adminLogoFile &&
                                                            <>
                                                                <div className="" style={{ display: "flex", height: "100%", position: "relative" }}>
                                                                    <img src={adminLogoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />
                                                                    <img src={DeleteIcon} style={{ width: "18px", height: "18px", position: "relative", top: "5px", left: "-20px", cursor: "pointer" }} onClick={(e: any) => removePhoto("adminprofileimage", setFieldValue)} />
                                                                </div>
                                                            </>
                                                        }
                                                        <Box className="UploadIcon" style={{ top: "80px", cursor: 'pointer' }} onClick={() => handleInputFile('admin')}>
                                                            {/* <img src={UploadIn} alt="" width={24} height={24} /> */}
                                                            <IconUpload stroke={1.8} color="#17B2EB" style={{width:"24px", height:"24px"}}/>
                                                             Upload Photo
                                                        </Box>
                                                    </Box>
                                                    {adminImageError 
                                                    // && touched.adminprofileimage 
                                                    && (
                                                        <div style={{ color: "#f44336", fontSize: "0.75rem" }}>{adminImageError}</div>
                                                    )}
                                                </>
                                            }

                                            {props?.customerInfo &&
                                                <Box className="UploadIcon1" style={{ width: '100%', height: '120px', border: '1px dashed #5A5F60', borderRadius: '8px', background: '#192529', textAlign: 'center', verticalAlign: 'middle' }}>
                                                    {adminLogoFile &&
                                                        <img src={adminLogoFile} style={{ height: '100%', width: 'auto', float: 'left' }} />
                                                    }
                                                </Box>
                                            }
                                        </RBFORM.Group>
                                    </Grid>

                                    <Field
                                        name="partnerid"
                                        type="hidden"
                                        component={TextField}
                                        className="inputC"
                                        value={partnerId}
                                    />
                                </Grid>
                            </Row>




                            <Stack className="fStacky" direction="row" spacing={2} justifyContent="flex-end"
                                sx={{
                                    backgroundColor: '#03171F',
                                    boxShadow: '-4px -4px 20px #91959621', borderTop: '1px solid #5A5F60', padding: 2,
                                }}>
                                <Button onClick={(e) => handleCancel(e)} variant="outlined" sx={{ marginRight: 'auto !important', color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                                    Cancel
                                </Button>
                                <Button type="submit" ref={saveexitFormBtn} onClick={() => { checkImageValidity(values); setFieldValue("submitButtonType", "save&exit") }} variant="outlined" sx={{ color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                                    Save & Exit
                                </Button>
                                <Button
                                    disabled={isSubmitting}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    startIcon={isSubmitting ? <CircularProgress size="0.9rem" /> : undefined}
                                    className="btnBlue"
                                    sx={{
                                        color: '#1F2F34', height: '41px', lineHeight: '41px',
                                        borderColor: '#0B4A62', background: '#17B2EB !important',
                                        borderRadius: '25px', fontSize: '14px',
                                        fontWidth: '500',
                                    }}
                                    onClick={() => { checkImageValidity(values); setFieldValue("submitButtonType", "next"); }}
                                >
                                    {isSubmitting ? "Creating..." : "Next"}
                                </Button>
                            </Stack>
                        </Form>
                        
                    </React.Fragment>
                )}
            </Formik >

            <AlertDialogs
                open={open}
                setOpen={setOpen}
                getConfirmResponse={getConfirmResponse}
                title="Confirm Cancel"
                message="Are you sure want to cancel registering the customer.<br/>Information if any entered will not be saved.<br/>To save the informtaion click Save & Exit"
                button1="Save & Exit"
                button2="Yes, Cancel"
            />
        </>
    );
}

// DynamicCoPIRBFORM.propTypes = CoPiValuePropTypes;